
export const showcase = {
    title: 'Catoo 作品展示',
    subtitle: '探索各种图像处理效果，体验专业AI技术的强大力量。',
    loadError: '加载展示图片失败，请稍后重试',
    featured: '精选',
    downloadStarted: '下载已开始',
    generatedImage: '生成的图片',
    noTitle: '无标题',
    noMoreImages: '没有更多图片了',
    noImagesFound: '未找到展示图片',
    noImagesDescription: '目前没有可用的展示图片。请稍后查看新内容！'
  };
